import _objectSpread from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _classCallCheck from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _possibleConstructorReturn from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";
import _inherits from "/home/runner/work/mozio-web/mozio-web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits.js";

function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }

  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}

import { __privateAdd, __privateGet, __privateMethod, __privateSet } from "./chunk-PXG64RU4.js"; // src/mutationObserver.ts

import { getDefaultState } from "./mutation.js";
import { notifyManager } from "./notifyManager.js";
import { Subscribable } from "./subscribable.js";
import { hashKey, shallowEqualObjects } from "./utils.js";

var _client, _currentResult, _currentMutation, _mutateOptions, _MutationObserver_instances, updateResult_fn, notify_fn;

var MutationObserver = /*#__PURE__*/function (_Subscribable) {
  function MutationObserver(client, options) {
    var _this2;

    _classCallCheck(this, MutationObserver);

    _this2 = _callSuper(this, MutationObserver);

    __privateAdd(_this2, _MutationObserver_instances);

    __privateAdd(_this2, _client);

    __privateAdd(_this2, _currentResult);

    __privateAdd(_this2, _currentMutation);

    __privateAdd(_this2, _mutateOptions);

    __privateSet(_this2, _client, client);

    _this2.setOptions(options);

    _this2.bindMethods();

    __privateMethod(_this2, _MutationObserver_instances, updateResult_fn).call(_this2);

    return _this2;
  }

  _inherits(MutationObserver, _Subscribable);

  return _createClass(MutationObserver, [{
    key: "bindMethods",
    value: function bindMethods() {
      this.mutate = this.mutate.bind(this);
      this.reset = this.reset.bind(this);
    }
  }, {
    key: "setOptions",
    value: function setOptions(options) {
      var _a;

      var prevOptions = this.options;
      this.options = __privateGet(this, _client).defaultMutationOptions(options);

      if (!shallowEqualObjects(this.options, prevOptions)) {
        __privateGet(this, _client).getMutationCache().notify({
          type: "observerOptionsUpdated",
          mutation: __privateGet(this, _currentMutation),
          observer: this
        });
      }

      if ((prevOptions == null ? void 0 : prevOptions.mutationKey) && this.options.mutationKey && hashKey(prevOptions.mutationKey) !== hashKey(this.options.mutationKey)) {
        this.reset();
      } else if (((_a = __privateGet(this, _currentMutation)) == null ? void 0 : _a.state.status) === "pending") {
        __privateGet(this, _currentMutation).setOptions(this.options);
      }
    }
  }, {
    key: "onUnsubscribe",
    value: function onUnsubscribe() {
      var _a;

      if (!this.hasListeners()) {
        (_a = __privateGet(this, _currentMutation)) == null ? void 0 : _a.removeObserver(this);
      }
    }
  }, {
    key: "onMutationUpdate",
    value: function onMutationUpdate(action) {
      __privateMethod(this, _MutationObserver_instances, updateResult_fn).call(this);

      __privateMethod(this, _MutationObserver_instances, notify_fn).call(this, action);
    }
  }, {
    key: "getCurrentResult",
    value: function getCurrentResult() {
      return __privateGet(this, _currentResult);
    }
  }, {
    key: "reset",
    value: function reset() {
      var _a;

      (_a = __privateGet(this, _currentMutation)) == null ? void 0 : _a.removeObserver(this);

      __privateSet(this, _currentMutation, void 0);

      __privateMethod(this, _MutationObserver_instances, updateResult_fn).call(this);

      __privateMethod(this, _MutationObserver_instances, notify_fn).call(this);
    }
  }, {
    key: "mutate",
    value: function mutate(variables, options) {
      var _a;

      __privateSet(this, _mutateOptions, options);

      (_a = __privateGet(this, _currentMutation)) == null ? void 0 : _a.removeObserver(this);

      __privateSet(this, _currentMutation, __privateGet(this, _client).getMutationCache().build(__privateGet(this, _client), this.options));

      __privateGet(this, _currentMutation).addObserver(this);

      return __privateGet(this, _currentMutation).execute(variables);
    }
  }]);
}(Subscribable);

_client = new WeakMap();
_currentResult = new WeakMap();
_currentMutation = new WeakMap();
_mutateOptions = new WeakMap();
_MutationObserver_instances = new WeakSet();

updateResult_fn = function updateResult_fn() {
  var _ref;

  var _a;

  var state = (_ref = (_a = __privateGet(this, _currentMutation)) == null ? void 0 : _a.state) !== null && _ref !== void 0 ? _ref : getDefaultState();

  __privateSet(this, _currentResult, _objectSpread(_objectSpread({}, state), {}, {
    isPending: state.status === "pending",
    isSuccess: state.status === "success",
    isError: state.status === "error",
    isIdle: state.status === "idle",
    mutate: this.mutate,
    reset: this.reset
  }));
};

notify_fn = function notify_fn(action) {
  var _this3 = this;

  notifyManager.batch(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;

    if (__privateGet(_this3, _mutateOptions) && _this3.hasListeners()) {
      var variables = __privateGet(_this3, _currentResult).variables;

      var context = __privateGet(_this3, _currentResult).context;

      if ((action == null ? void 0 : action.type) === "success") {
        (_b = (_a = __privateGet(_this3, _mutateOptions)).onSuccess) == null ? void 0 : _b.call(_a, action.data, variables, context);
        (_d = (_c = __privateGet(_this3, _mutateOptions)).onSettled) == null ? void 0 : _d.call(_c, action.data, null, variables, context);
      } else if ((action == null ? void 0 : action.type) === "error") {
        (_f = (_e = __privateGet(_this3, _mutateOptions)).onError) == null ? void 0 : _f.call(_e, action.error, variables, context);
        (_h = (_g = __privateGet(_this3, _mutateOptions)).onSettled) == null ? void 0 : _h.call(_g, void 0, action.error, variables, context);
      }
    }

    _this3.listeners.forEach(function (listener) {
      listener(__privateGet(_this3, _currentResult));
    });
  });
};

export { MutationObserver };